import { useNavigate } from 'react-router-dom';
/* [DEPRECATED 2026-06-30] - Previously used by hard-coded redirect (see comment below).
 * Kept for reference; no longer referenced after switching to role-based landing path.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ROUTE_PATH } from 'src/routes/route.constant';
import { useProfileStore } from '../profile/useProfileStore';

/* [DEPRECATED 2026-06-30] - Hard-coded redirect to /question-management caused 404 for
 * TEACHER / FORM_TEACHER / SCHOOL_MANAGER because that path is in their IGNORE_ROLE_* list.
 *
 *   const onLogin = async (data: IAuth) => {
 *     try {
 *       setAuthData(data);
 *       await requestGetProfile();
 *       navigate(ROUTE_PATH.QUESTION_MANAGEMENT);
 *     } catch (error) {}
 *   };
 */

// [NEW 2026-06-30] - Use role-aware landing path via usePermission.getDefaultLandingPath.
import { getDefaultLandingPath } from 'src/hook/usePermission';

export const LOCAL_STORAGE_KEY = 'LMS_ADMIN';
export const LOCAL_STORAGE_PARAM_SEARCH = 'PARAM_SEARCH_QUESTION';

interface IAuth {
  accessToken: string;
  refreshToken: string;
  role: string;
}

export const getAuthLocalStorage = () => {
  try {
    const authData = localStorage.getItem(LOCAL_STORAGE_KEY);
    return authData && JSON.parse(authData);
  } catch (error) {}
};

export const getAccessToken = () => {
  const data: any = getAuthLocalStorage();

  return data?.accessToken || '';
};

export const getRefreshToken = () => {
  const data: any = getAuthLocalStorage();

  return data?.refreshToken || '';
};

export const getRoleAccount = () => {
  const data: any = getAuthLocalStorage();

  return data?.role || '';
};

export const setAuthData = (data: IAuth): void => {
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(data));
};

export const deleteAuthData = (): void => {
  localStorage.removeItem(LOCAL_STORAGE_KEY);
  localStorage.removeItem(LOCAL_STORAGE_PARAM_SEARCH);
};

export const useAuthStore = () => {
  const navigate = useNavigate();
  const { requestGetProfile } = useProfileStore();

  const onLogout = async () => {
    try {
      deleteAuthData();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  const onLogin = async (data: IAuth) => {
    try {
      setAuthData(data);

      await requestGetProfile();

      navigate(getDefaultLandingPath(data.role));
    } catch (error) {}
  };

  return {
    onLogin,
    onLogout,
  };
};
